export default {
  purchaseDetails: {},
  purchaseDetailsRequestStatus: {
    isLoading: false,
    isError: false
  },
};
